export interface Voice {
  name: string;
  role: string;
  content: string;
}

export const voices: Voice[] = [
  {
    name: '小满',
    role: '通勤党',
    content: '以前刷到热搜都是一头雾水，看热闹却不知道前因后果。这里的脉络梳理得很清楚，两分钟就补上进度了。',
  },
  {
    name: '阿泽',
    role: '内容从业者',
    content: '观点归类做得挺克制，正反方都摆在明面上，不会只推一种声音。这点对做选题的我很有参考价值。',
  },
  {
    name: '林小舟',
    role: '大学生',
    content: '最喜欢看评论区的精选留言，感觉像把一整晚的讨论浓缩成了几条，省时间还不失氛围。',
  },
  {
    name: '老周',
    role: '产品经理',
    content: '热度值和风向图做得直观，能看到一个话题是在升温还是冷却，比单纯看数字有意思。',
  },
  {
    name: '晚风',
    role: '自由撰稿人',
    content: '更新挺及时，有进展会补进时间线，错了也会标注更正。这种态度在同类站点里不多见。',
  },
  {
    name: '陈默',
    role: '普通网友',
    content: '界面干净，没有花里胡哨的弹窗，就是安安静静看大家讨论，挺舒服的。',
  },
];